import script from "./custom_dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./custom_dropdown.vue?vue&type=script&setup=true&lang=js"

import "./custom_dropdown.vue?vue&type=style&index=0&id=04a338a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a338a8"]])

export default __exports__